import React, { useState, useRef } from 'react'
import { createItem, deleteItemById, getAllItems, updateItem } from '../../service/apiService';
import CardItem from '../card/CardItem';
import Modal from '../common/Modal';
import BoxForm from './BoxForm';
import StockField from './StockField';
import './Admin.css';

// Matches items.description VARCHAR(1255) in items-service (and the check in
// the backend's AdminController).
const MAX_DESCRIPTION_LENGTH = 1255;

function AdminProducts() {
    const [pageItem, setPageItem] = useState(1);
    const [updateId, setUpdateId] = useState(null);
    // Which box product is open for editing (boxes have their own form, BoxForm).
    const [editBoxId, setEditBoxId] = useState(null);
    const [error, setError] = useState('');
    // Every error message clears itself after 8 seconds (it used to stay on
    // screen until the next successful action). A newer message restarts the
    // clock instead of being wiped by the previous message's timer.
    const errorTimer = useRef(null);
    const showError = (message) => {
        setError(message);
        clearTimeout(errorTimer.current);
        errorTimer.current = setTimeout(() => setError(''), 8000);
    };
    const [item, setItem] = useState([]);
    const [file, setFile] = useState(null);
    // Separate from `file` (the create form's) on purpose - sharing one
    // state let a stale File picked earlier in the create form leak into an
    // unrelated later edit that never touched the photo.
    const [updateFile, setUpdateFile] = useState(null);
    // Holds the just-added product's name while the success confirmation is
    // open; null means closed. Set right before the form resets below, so
    // the confirmation still shows the name that was actually submitted.
    const [addedItemName, setAddedItemName] = useState(null);
    const [addedKind, setAddedKind] = useState('מוצר');
    const [itemsFrom, setItemsFrom] = useState({
        name: '',
        description: '',
        price: 0,
        image: file,
        category: '',
        veg: false,
        // Units left to sell; null/empty = stock is not tracked for this product.
        stock: null,

    });

    // The stock field as the backend wants it: a whole number, or null for "not tracked".
    const stockValue = () => (itemsFrom.stock === null || itemsFrom.stock === undefined || itemsFrom.stock === ''
        ? null
        : Number(itemsFrom.stock));
    const stockIsInvalid = () => {
        const stock = stockValue();
        return stock !== null && (!Number.isInteger(stock) || stock < 0);
    };
    const onStockChange = (e) => setItemsFrom({ ...itemsFrom, stock: e.target.value === '' ? null : parseInt(e.target.value, 10) });

    // Chocolates (pralines) have no price of their own - the box they go into
    // is what is priced - so the form neither asks for one nor requires it.
    const isChocolate = itemsFrom.category === 'chocolate';

    const handelItems = async () => {
        try {
            const { data } = await getAllItems(pageItem);
            setPageItem(prev => prev + 1);
            setItem(prev => [...prev, ...data]);
        } catch (error) {
            if (error.response?.status === 400 || error.response?.status === 500) {
                showError(error.response.data);
            }
        }
    }
    const handleCreateItem = async (e) => {
        e.preventDefault();
        if (!file || !itemsFrom.name || !itemsFrom.description || (!isChocolate && !itemsFrom.price) || !itemsFrom.category) {
            showError('יש למלא את כל השדות ולהעלות תמונה');
            return;
        }
        if (!isChocolate && Number(itemsFrom.price) <= 0) {
            showError('המחיר חייב להיות גדול מ-0');
            return;
        }
        if (stockIsInvalid()) {
            showError('המלאי חייב להיות מספר שלם, 0 או יותר');
            return;
        }
        const formData = new FormData();
if (!(file instanceof File)) {
    showError('הקובץ לא תקין, יש לבחור תמונה');
    return;
}
        const realFile = new File([file], "upload.jpg", { type: file.type || "image/jpeg" });

        formData.append('file', realFile);
        formData.append('item', new Blob([JSON.stringify({
            name: itemsFrom.name.trim(),
            category: itemsFrom.category.trim(),
            description: itemsFrom.description.trim(),
            price: isChocolate ? 0 : Number(itemsFrom.price),
            veg: itemsFrom.veg,
            stock: stockValue()
        })], { type: 'application/json' }));
        try {


            await createItem(formData);
            setAddedKind('מוצר');
            setAddedItemName(itemsFrom.name.trim());
            setItemsFrom({
                name: '',
                description: '',
                price: 0,
                image: null,
                category: '',
                veg: false,
                stock: null
            });
            setItem([]);
            setPageItem(1);
            handelItems();

        } catch (error) {
            if (error.response?.status === 400 || error.response?.status === 500) {
                showError(error.response.data);
            }
            if (error.code === "ERR_NETWORK") {
                showError("שגיאת רשת: בדוק/י את החיבור לאינטרנט ונסה/י שוב.");
            }
        }
    };
    // Back to the first page of products (handelItems alone would fetch the
    // page after the one already loaded).
    const reloadItems = async () => {
        try {
            const { data } = await getAllItems(1);
            setItem(data);
            setPageItem(2);
        } catch (error) {
            showError('לא הצלחנו לרענן את רשימת המוצרים');
        }
    };
    // BoxForm shows the server's error itself, so these only send and refresh.
    const createBox = async (formData, name) => {
        await createItem(formData);
        setAddedKind('מארז');
        setAddedItemName(name);
        reloadItems();
    };
    const saveBox = async (formData) => {
        await updateItem(formData);
        setEditBoxId(null);
        reloadItems();
    };
    // Was window.confirm() - a native browser popup, not styled at all.
    // Now opens the shared Modal (same one PhoneNumberPrompt already uses)
    // instead - deleteTarget holds the pending item's id while it's open.
    const [deleteTarget, setDeleteTarget] = useState(null);
    const confirmDelete = async () => {
        if (deleteTarget == null) {
            return;
        }
        try {
            await deleteItemById(deleteTarget);
            setItem(item.filter(i => i.id !== deleteTarget));
        } catch (error) {
            if (error.response?.status === 400 || error.response?.status === 500) {
                showError(error.response.data);
            }
        }
        setDeleteTarget(null);
    }
    const toggleupdate = (id) => {
        setUpdateId(id === updateId ? null : id);
        // Opening a different edit, or canceling one - either way, any
        // photo picked for a previous edit session must not carry over.
        setUpdateFile(null);
        const itemToEdite = item.find(item => item.id === id);
        if (itemToEdite) {
            setItemsFrom({ ...itemToEdite })
        };
    };
    const updateItemId = async (e) => {
        e.preventDefault();
        if (!isChocolate && Number(itemsFrom.price) <= 0) {
            showError('המחיר חייב להיות גדול מ-0');
            return;
        }
        if (stockIsInvalid()) {
            showError('המלאי חייב להיות מספר שלם, 0 או יותר');
            return;
        }
        // A new photo is optional here (unlike create) - only attach a
        // 'file' part when the admin actually picked one this edit; its
        // absence tells the backend to keep the item's existing image
        // untouched.
        if (updateFile && !(updateFile instanceof File)) {
            showError('הקובץ לא תקין, יש לבחור תמונה');
            return;
        }
        const formData = new FormData();
        if (updateFile) {
            const realFile = new File([updateFile], "upload.jpg", { type: updateFile.type || "image/jpeg" });
            formData.append('file', realFile);
        }
        formData.append('item', new Blob([JSON.stringify({
            id: updateId,
            name: itemsFrom.name.trim(),
            category: itemsFrom.category.trim(),
            description: itemsFrom.description.trim(),
            price: isChocolate ? 0 : Number(itemsFrom.price),
            veg: itemsFrom.veg,
            stock: stockValue()
        })], { type: 'application/json' }));
        try {
            await updateItem(formData);
            setUpdateId(null);
            setUpdateFile(null);
            // Re-fetch rather than merge itemsFrom locally - itemsFrom still
            // holds the OLD image URL (copied in toggleupdate before any
            // replace happened), so a local merge would keep showing the
            // old photo until a manual page refresh even though the
            // replace actually succeeded. Same refresh pattern already used
            // after a CSV import below.
            setItem([]);
            setPageItem(1);
            handelItems();
        } catch (error) {
            if (error.response?.status === 400 || error.response?.status === 500) {
                showError(error.response.data);
            }
        };
    }

    return (
        <div className='admin-products'>
            {error && <p className='admin-error'>{error}</p>}

            <form onSubmit={handleCreateItem} className='form_item'>
                <h2 className='tital'>הוספת מוצר</h2>
                <input type="text" placeholder="שם במוצר" value={itemsFrom.name} onChange={(e) => setItemsFrom({ ...itemsFrom, name: e.target.value })} />
                <textarea placeholder="תיאור" rows={4} maxLength={MAX_DESCRIPTION_LENGTH} value={itemsFrom.description} onChange={(e) => setItemsFrom({ ...itemsFrom, description: e.target.value })} />
                <span className="desc-counter">{itemsFrom.description.length}/{MAX_DESCRIPTION_LENGTH}</span>
                {!isChocolate && <input type="number" placeholder="מחיר" value={itemsFrom.price} onChange={(e) => setItemsFrom({ ...itemsFrom, price: parseFloat(e.target.value) })} />}
                <StockField value={itemsFrom.stock} onChange={onStockChange} />
                <input type="file" placeholder="העלאת תמונה"   accept="image/*"  onChange={(e) => setFile(  e.target.files[0] )} />
                <select value={itemsFrom.category} onChange={(e) => setItemsFrom({ ...itemsFrom, category: e.target.value })}>
                    <option value="">בחר קטגוריה</option>
                    <option value="chocolate">שוקולד</option>
                    <option value="cake">עוגה</option>
                    <option value="cookie">עוגיה</option>
                </select>
                <label>
                    צמחוני:
                    <input type="checkbox" checked={itemsFrom.veg} onChange={(e) => setItemsFrom({ ...itemsFrom, veg: e.target.checked })} />
                </label>
                <button className='btn' type="submit">תוסיף מוצר</button>
            </form>

            <BoxForm onSave={createBox} />

            <h2 className='tital'>מוצרים</h2>
            <div className='items_container'>

                {item.length > 0 && item.map(item => (
                    <div key={item.id} >
                        <CardItem item={item} />
                        <p className='admin-stock'>{item.stock == null ? 'מלאי: לא נספר' : (item.stock <= 0 ? 'מלאי: 0 - חסר במלאי' : `מלאי: ${item.stock}`)}</p>
                        <button className='btn' type='button' onClick={() => setDeleteTarget(item.id)}>מחיקה</button>
                        {(item.category || '').startsWith('chocolate-box-') ? (
                            <>
                                <button className='btn' type='button' onClick={() => setEditBoxId(editBoxId === item.id ? null : item.id)}>
                                    {editBoxId === item.id ? 'ביטול' : 'עריכה'}
                                </button>
                                {editBoxId === item.id && <BoxForm initial={item} onSave={saveBox} onCancel={() => setEditBoxId(null)} />}
                            </>
                        ) : (
                            <button className='btn' type='button' onClick={() => toggleupdate(item.id)}>
                                {updateId === item.id ? 'ביטול' : 'עריכה'}
                            </button>
                        )}
                        {updateId === item.id && !(item.category || '').startsWith('chocolate-box-') && (
                            <form onSubmit={updateItemId} className='form_item'>

                                <input type="text" placeholder="שם המוצר" value={itemsFrom.name} onChange={(e) => setItemsFrom({ ...itemsFrom, name: e.target.value })} />
                                <textarea placeholder="תיאור" rows={4} maxLength={MAX_DESCRIPTION_LENGTH} value={itemsFrom.description} onChange={(e) => setItemsFrom({ ...itemsFrom, description: e.target.value })} />
                                <span className="desc-counter">{itemsFrom.description.length}/{MAX_DESCRIPTION_LENGTH}</span>
                                {!isChocolate && <input type="number" placeholder="מחיר" value={itemsFrom.price} onChange={(e) => setItemsFrom({ ...itemsFrom, price: parseFloat(e.target.value) })} />}
                                <StockField value={itemsFrom.stock} onChange={onStockChange} />
                                <input type="file" placeholder="העלאת תמונה" accept="image/*" onChange={(e) => setUpdateFile(e.target.files[0])} />
                                <select value={itemsFrom.category} onChange={(e) => setItemsFrom({ ...itemsFrom, category: e.target.value })}>
                                    <option value="">בחר קטגוריה</option>
                                    <option value="chocolate">שוקולד</option>
                                    <option value="cake">עוגה</option>
                                    <option value="cookie">עוגיה</option>
                                </select>
                                <label>  צמחוני:  <input className='veg' type="checkbox" checked={itemsFrom.veg} onChange={(e) => setItemsFrom({ ...itemsFrom, veg: e.target.checked })} /> </label>
                                <button className='btn' type="submit">שמירה</button>
                            </form>

                        )}
                    </div>
                ))}

            </div>
            <button className='btn' onClick={handelItems}>קבל מוצרים</button>
            <Modal
                isOpen={deleteTarget !== null}
                onClose={() => setDeleteTarget(null)}
                title="מחיקת מוצר"
                footer={
                    <>
                        <button className='btn' type='button' onClick={() => setDeleteTarget(null)}>ביטול</button>
                        <button className='btn btn-cancel' type='button' onClick={confirmDelete}>מחיקה</button>
                    </>
                }
            >
                <p>למחוק את המוצר הזה? הפעולה בלתי הפיכה.</p>
            </Modal>
            <Modal
                isOpen={addedItemName !== null}
                onClose={() => setAddedItemName(null)}
                title={`ה${addedKind} נוסף בהצלחה`}
                footer={
                    <button className='btn' type='button' onClick={() => setAddedItemName(null)}>אישור</button>
                }
            >
                <p>ה{addedKind} "{addedItemName}" נוסף בהצלחה לקטלוג.</p>
            </Modal>
        </div>
    )
}

export default AdminProducts
